import { render, staticRenderFns } from "./active-users.vue?vue&type=template&id=bf5432ac&scoped=true&"
import script from "./active-users.vue?vue&type=script&lang=js&"
export * from "./active-users.vue?vue&type=script&lang=js&"
import style0 from "./active-users.vue?vue&type=style&index=0&id=bf5432ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5432ac",
  null
  
)

export default component.exports